"use strict";

// import styles from './menu.css';

var isHome, menuTrg, menu;

function menuTrgToggle() {
    var delay = 0,
        isSearching = document.body.classList.contains("is-searching"),
        menuOpened = document.body.classList.contains("is-menu-opened"),
        subMenuItem = menu.querySelector(".menu-item-has-children.is-active");

    if (isSearching) {
        searchTrgToggle();
        return;
    }

    if (subMenuItem && !menuOpened) {
        subMenuItem.classList.remove("is-active");
        subMenuItem = null;
        delay = 200;
    }

    setTimeout(function () {
        if (subMenuItem) {
            var subMenu = subMenuItem.querySelector(".sub-menu");
            subMenu.classList.add("is-animating");
            subMenuItem.classList.remove("is-active");
            menu.removeEventListener("click", menuTrgToggle);
        } else {
            menu.classList.add("is-animating");

            if (!menuOpened) {
                document.body.classList.add("is-menu-opened");
            } else {
                document.body.classList.remove("is-menu-opened");
            }
        }
    }, delay);
}

function onTransitionEnd(e) {
    e.target.classList.remove("is-animating");
}

function menuTrgHide() {
    document.body.classList.remove("is-menu-opened");
}

function menuItemClick(e) {
    e.stopPropagation();

    const vw = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    );

    if (vw > 1024) {
        return;
    }

    const menuItem = e.target.parentNode;

    if (menuItem.classList.contains("menu-item-has-children")) {
        e.preventDefault();

        const subMenu = menuItem.querySelector(".sub-menu");
        subMenu.classList.add("is-animating");
        menuItem.classList.add("is-active");

        menu.addEventListener("click", menuTrgToggle);
    } else {
        menuTrgHide();
    }
}

function configMenu() {
    var i,
        len,
        menuTrg = document.querySelector(".menu-trg");

    isHome = document.body.classList.contains("home");
    menu = document.getElementById("access");

    menuTrg.addEventListener("click", menuTrgToggle);
    menu.addEventListener("transitionend", onTransitionEnd);

    const itemsWithChildren = menu.querySelectorAll(".menu-item-has-children");
    for (let menuItem of itemsWithChildren) {
        const link = menuItem.querySelector("a");
        const subMenu = menuItem.querySelector(".sub-menu");

        if (link && subMenu && link.getAttribute("href") !== "#") {
            const newItemLink = document.createElement("a");
            newItemLink.setAttribute("href", link.getAttribute("href"));
            newItemLink.textContent = link.textContent;

            const newItem = document.createElement("li");
            newItem.classList.add("menu-item");
            newItem.classList.add("sub-menu__parent-cloned");
            newItem.appendChild(newItemLink);

            subMenu.prepend(newItem);
        }
    }

    const menuItems = menu.querySelectorAll(".menu a");
    for (let menuItem of menuItems) {
        menuItem.addEventListener("click", menuItemClick, false);

        if (!isHome) {
            var href = menuItem.getAttribute("href");

            if (href.indexOf("#") === 0) {
                menuItem.setAttribute("href", jprVars.homeUrl + "/" + href);
            }
        }
    }
}

(function () {
    configMenu();
})();



// WEBPACK FOOTER //
// ./js/menu.js